import React from "react"
import PropTypes from 'prop-types'
import moment from 'moment'
import FooterTop from './FooterTop'
import CookiesMessage from "./Cookies"


const Footer = (props, context) => {
    let {renderFooterTop} = props
    let {formatMessage} = context
    return (
        <footer key="2" className="footer">
            {
                renderFooterTop &&
                <FooterTop />
            }
            <CookiesMessage formatMessage={formatMessage}/>
            <div className="container">
                <div className="footer-content">
                    <span>&copy; {formatMessage('Copyright')} {moment().format('YYYY')} QBM</span>
                </div>
            </div>
        </footer>
    )
}

Footer.contextTypes = {formatMessage: PropTypes.any}

export default Footer


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Footer/index.js